module.exports = __webpack_public_path__ + "img/stickers_0016_salad.2941615b.png";